import { logger } from '@/core/logger';
import { useAppStore } from '@/core/stores/appStore';
import { RegistrationStorage } from '@/modules/onboarding/registration/storage/registrationStorage';

/**
 * Get the target route for UAE Pass registration based on current state
 * This is used by splash screen to determine where to route
 */
export async function getUaePassRegistrationRoute(): Promise<string | null> {
    const uaePassRegistration = useAppStore.getState().uaePassRegistration;

    // Check if UAE Pass registration is in progress
    if (!uaePassRegistration?.customerId || !uaePassRegistration?.registrationId) {
        logger.debug('UaePassRegistrationRouting:No active UAE Pass registration');
        return null;
    }

    logger.info('UaePassRegistrationRouting:UAE Pass registration detected', {
        hasCustomerId: !!uaePassRegistration.customerId,
        hasRegistrationId: !!uaePassRegistration.registrationId,
        hasUser: !!uaePassRegistration.user,
    });

    // Check if user has reached registration success
    const hasReachedSuccess = await RegistrationStorage.hasReachedRegistrationSuccess();
    if (hasReachedSuccess) {
        logger.info('UaePassRegistrationRouting:User has reached registration success, routing to success screen');
        return '/registration-success';
    }

    // UAE Pass flow: After callback, user goes to details screen
    // If user data exists, route to details screen
    if (uaePassRegistration.user) {
        logger.info('UaePassRegistrationRouting:User data exists, routing to UAE Pass details screen');
        return '/uae-pass-details';
    }

    // Otherwise, start UAE Pass auth
    logger.info('UaePassRegistrationRouting:No user data, routing to UAE Pass auth screen');
    return '/uaepass';
}

/**
 * Check if UAE Pass registration is ongoing
 */
export function isUaePassRegistrationOngoing(): boolean {
    const uaePassRegistration = useAppStore.getState().uaePassRegistration;
    const isOngoing = !!(uaePassRegistration?.customerId && uaePassRegistration?.registrationId);
    logger.debug('UaePassRegistrationRouting:Checking if UAE Pass registration is ongoing', { isOngoing });
    return isOngoing;
}

